function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.087 5.217h7.826a.522.522 0 00.522-.521V3.652a.522.522 0 00-.522-.522H1.565C.701 3.13 0 3.831 0 4.696v17.739C0 23.299.7 24 1.565 24h17.74c.864 0 1.565-.7 1.565-1.565v-8.348a.522.522 0 00-.522-.522h-1.044a.522.522 0 00-.521.522v7.826H2.087V5.217z",
  fill: "#B5BFCD"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.437 2.087H15.13a.522.522 0 01-.521-.522V.522c0-.288.233-.522.521-.522h8.348c.288 0 .522.234.522.522V8.87a.522.522 0 01-.522.521h-1.043a.522.522 0 01-.522-.521V3.563L11.542 13.934a.522.522 0 01-.738 0l-.738-.738a.522.522 0 010-.738L20.437 2.087z",
  fill: "#B5BFCD"
});

var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref, _ref2);
};

export default SvgLink;